<template>
  <div class="cont">
    <div class="left animate__animated animate__fadeInLeft">
      <img v-for="(item, index) in list" :key="item.id" :src="$baseURL + item.thumb" :alt="item.title"
        v-show="index == activeIndex" />
    </div>
    <ul class="right animate__animated animate__fadeInRight">
      <router-link v-for="(item, index) in list" :key="item.id" :to="{ path: '/news/info', query: { id: item.id } }"
        @mouseover="activeIndex = index">
        <div class="date" v-if="item.posttime">
          <h5>{{ item.posttime.split("/")[0] }}</h5>
          /{{ item.posttime.split("/")[1] }}
        </div>
        <div v-else class="date">
          <h5>{{ item.day }}</h5>
          /{{ item.month }}
        </div>
        <p class="dh_text">{{ item.title }}</p>
      </router-link>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
    },
  },
  data() {
    return {
      activeIndex: 0,
    };
  },
};
</script>

<style lang="less" scoped>
.cont {
  display: flex;
  border-radius: 15px;
  overflow: hidden;

  .left {
    width: 52%;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center;
    }
  }

  .right {
    flex: 1;
    padding: 70px;
    background: #fff;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    a {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .date {
        display: flex;
        align-items: flex-end;
        line-height: 1.2;
        color: #999;
        font-size: 14px;
        transition: all 0.3s;

        h5 {
          transition: all 0.3s;
          color: #333;
          font-size: 26px;
          line-height: 1;
        }
      }

      .dh_text {
        transition: all 0.3s;
        max-width: 75%;
        font-size: 22px;
        color: #333;
      }

      &+a {
        padding-top: 6%;
        border-top: 1px solid #eee;
      }

      &::after {
        content: "";
        position: absolute;
        left: -70px;
        top: 75%;
        width: 0;
        height: 2px;
        background: var(--themeColor2);
        transition: all 0.3s;
      }

      &:hover {
        .date {
          color: var(--themeColor2);

          h5 {
            color: var(--themeColor2);
          }
        }

        .dh_text {
          color: var(--themeColor2);
        }

        &::after {
          width: 50px;
        }
      }
    }
  }
}

@media (max-width: 820px) {
  .cont {
    display: block;

    .left,
    .right {
      width: 100%;
      flex: auto;
    }

    .right {
      padding: 20px;
      box-sizing: border-box;

      a {
        .date {
          h5 {
            font-size: 20px;
          }
        }

        .dh_text {
          font-size: 16px;
        }
      }
    }
  }
}
</style>